import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  OnDestroy,
  AfterViewInit,
  inject,
  signal,
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Store } from "@ngrx/store";
import {
  FaStackComponent,
  FaIconComponent,
  FaStackItemSizeDirective,
} from "@fortawesome/angular-fontawesome";

import { CoreActions } from "src/app/core/store/actions";
import { Seo } from "src/app/core/services/seo.service";
import { environment } from "src/environments/environment";
import { AnchorScrollComponent } from "src/app/core/components/anchor-scroll/anchor-scroll.component";

@Component({
  selector: "audio-contact",
  templateUrl: "./contact.component.html",
  styleUrls: ["./contact.component.sass"],
  imports: [
    FaStackComponent,
    FaIconComponent,
    FaStackItemSizeDirective,
    AnchorScrollComponent,
  ],

  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContactComponent implements OnInit, OnDestroy, AfterViewInit {
  private store = inject<Store>(Store);
  private seo = inject(Seo);
  private route = inject(ActivatedRoute);
  public $fragment = signal<string | null>(null);

  constructor() {
    this.seo.setMeta({ name: "robots", content: "noindex" });
    this.store.dispatch(
      new CoreActions.SetBreadcrumb({
        label: "Contact",
        slug: "contact",
        entity: "page",
      }),
    );
    this.seo.setMeta({ property: "og:type", content: "website" });
    this.seo.setTitle("CONTACT | " + environment.title);
    this.seo.setDescription(`Contactez nous !`);
    this.seo.setMeta(null);
    this.seo.setMeta({ property: "product:price:amount", content: "0" });
  }

  ngOnInit(): void {
    this.route.fragment.subscribe((fragment) => {
      this.$fragment.set(fragment);
    });
  }

  ngAfterViewInit(): void {
    if (this.$fragment()) {
      const element = document.querySelector("#" + this.$fragment());
      if (element) {
        element.scrollIntoView();
      }
    }
  }

  ngOnDestroy(): void {
    this.seo.unsetMeta({ name: "robots", content: "noindex" });
  }
}
